<div class="esri-map" [id]="container"></div>
<ng-template cdkPortalOutlet></ng-template>
<ng-content></ng-content>
